import { hexToRgb } from '@website/common/utils'

export default {
  DARK: {
    heading: p => p.accentWhite,
    subheading: p => p.primaryLight,
    paragraph: p => p.accentWhite,
    slogan: p => p.accentWhite,
    backgroundColor: p => p.tertiaryDark,
    background: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.primaryDark,
    subheading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    slogan: p => p.accentWhite,
    backgroundColor: p => p.tertiaryLight,
    background: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    subheading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    slogan: p => p.accentWhite,
    backgroundColor: p => p.tertiaryExtraLight,
    background: p => p.tertiaryExtraLight
  }
}
